<div #environment class="row environment" *ngIf="!cs.environment.isProd">
  <div class="row col-sm-12 {{ this.cs.config.env }}" style="text-align: center">
    <h2>
      {{ this.cs.config.env }}
    </h2>
  </div>
</div>
